import React, { useEffect, useState } from "react";
import apiRequest from "../../../utils/ApiRequest/apiRequest.js";
import { useNavigate } from "react-router-dom";
import { useContent } from "../../../contexts/contentContext/contentContext.js";
import useMediaQueries from "../../../hooks/useMediaQueries.js";
import CreatorPageDesktop from "./CreatorPageDesktop.js";
import CreatorPageMobile from "./CreatorPageMobile.js";
import { useParams } from "react-router-dom";

const CreatorPage = () => {
  const [creator, setCreator] = useState();
  const { getLanguageCulture, getPath } = useContent();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { mobileCondition } = useMediaQueries();
  const params = useParams();

  useEffect(() => {
    setLoading(true);
    apiRequest(
      "Creator",
      `ReactGetCreatorByKey?creatorKey=${
        params.creatorUrl
      }&creatorCulture=${getLanguageCulture().substring(0, 2)}`
    ).then((response) => {
      if (response.status !== "success") {
        navigate(getPath() + "error/no-creator-id");
      }
      setCreator(response.data);
      setLoading(false);
    });
  }, []);

  return mobileCondition ? (
    <CreatorPageMobile creator={creator} loading={loading} />
  ) : (
    <CreatorPageDesktop creator={creator} loading={loading} />
  );
};

export default CreatorPage;
